import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import "../../styles/Favourites.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const OfferDetail = () => {
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    let { state } = useLocation();
    let { offer_detail } = state;
    const [offerDetails, setOfferDetails] = useState(offer_detail);
    const [productDetails, setProductDetails] = useState('');

    useEffect(() => {
        setOfferDetails(offer_detail);
        if (offerDetails.type === 1) {
            ApiCall("getNotificationById", {
                customer_id: user && user.id > 0 && user.id,
                offer_id: offerDetails.id,
            })
                .then((data) => {
                    if (data.message === "Notification listed successfully.") {
                        setProductDetails(data.data[0].product[0]);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [offer_detail]);

    const handleClick = (data) => {
        navigate("/product-details", { state: { p_detail: data } });
    };
    return (
        <>
            <Header make={true} />
            {
                offerDetails != null ?
                    <div style={{ minHeight: "100%" }}>
                        <div className="offer-detail-banner">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6 offer-ban">
                                        {/* <img
                                            role={"button"}
                                            src={Web_url.Domain_url + offerDetails.image}
                                            alt="offer"
                                            className="detail-img"
                                        /> */}
                                        <picture><img
                                                role={"button"}
                                                src={Web_url.Domain_url + offerDetails.image}
                                                alt="offer"
                                                className="detail-img"
                                            /> </picture>
                                    </div>
                                    <div className="col-md-6 offer-ban">
                                        <p className="det-title">{offerDetails.title}</p>
                                        {
                                            offerDetails.type === 1 ?
                                                <p className="det-dis">Min {offerDetails.discount} %</p> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container py-4">
                            <div className="back_button">
                                <a
                                    href="javascript:history.go(-1)"
                                    style={{ textDecoration: "none" }}
                                >
                                    <button
                                        className="btn btn-sm"
                                        style={{
                                            backgroundColor: Colors.Base_color,
                                            color: "white",
                                        }}
                                    >
                                        <div className="d-flex align-items-center gap-2 mx-2">
                                            <i
                                                class="fa-solid fa-caret-left"
                                                style={{ fontSize: "18px" }}
                                            ></i>
                                            <span style={{ paddingTop: "1px" }}>Back</span>
                                        </div>
                                    </button>
                                </a>
                            </div>
                            <p className="offer-head">Offers Description</p>
                            <div className="row justify-content-center">
                                <div className="col-md-12 col-10">
                                    <p className="detail-desc">{offerDetails.description}</p>
                                </div>
                            </div>
                            {offerDetails.type === 1 ? <button className="let-btn" onClick={() => handleClick(productDetails)}>Shop now</button> : null}
                        </div>
                    </div> : null
            }
            <Footer />
        </>
    );
}


export default OfferDetail;
